/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Tea_Lot_Delete_ErrorInputs */

const vi_toast_tea_lot_delete_error = /** @type {(inputs: Toast_Tea_Lot_Delete_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xóa lô chè thất bại`)
};

/**

* @param {Toast_Tea_Lot_Delete_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_tea_lot_delete_error = /** @type {((inputs?: Toast_Tea_Lot_Delete_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Tea_Lot_Delete_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_tea_lot_delete_error(inputs)
});